import { supabase } from "../../config/supabase";
import { Company } from "./companies";

interface ProductPrice {
  id: string;
  product_id: string;
  company_id: string;
  price_per_kg: number;
  created_at?: string;
  updated_at?: string;
  companies?: Company;
}

interface ServiceResponse<T> {
  success: boolean;
  data?: T;
  error?: any;
}

class ProductPricesService {
  async listPricesByProduct(
    productId: string
  ): Promise<ServiceResponse<ProductPrice[]>> {
    try {
      const { data, error } = await supabase
        .from("product_prices")
        .select(
          `
          id,
          price_per_kg,
          companies (
            id,
            company_name
          )
        `
        )
        .eq("product_id", productId);

      if (error) throw error;
      return { success: true, data };
    } catch (error) {
      console.error("Error fetching product prices:", error);
      return { success: false, error };
    }
  }

  async createPrice(
    productId: string,
    companyId: string,
    pricePerKg: number
  ): Promise<ServiceResponse<ProductPrice>> {
    try {
      const { data, error } = await supabase
        .from("product_prices")
        .insert({
          product_id: productId,
          company_id: companyId,
          price_per_kg: pricePerKg,
        })
        .select()
        .single();

      if (error) throw error;
      return { success: true, data };
    } catch (error) {
      console.error("Error creating product price:", error);
      return { success: false, error };
    }
  }

  async updatePrice(
    priceId: string,
    pricePerKg: number
  ): Promise<ServiceResponse<ProductPrice>> {
    try {
      const { data, error } = await supabase
        .from("product_prices")
        .update({ price_per_kg: pricePerKg })
        .eq("id", priceId)
        .select()
        .single();

      if (error) throw error;
      return { success: true, data };
    } catch (error) {
      console.error("Error updating product price:", error);
      return { success: false, error };
    }
  }

  async deletePrice(priceId: string): Promise<ServiceResponse<void>> {
    try {
      const { error } = await supabase
        .from("product_prices")
        .delete()
        .eq("id", priceId);

      if (error) throw error;
      return { success: true };
    } catch (error) {
      console.error("Error deleting product price:", error);
      return { success: false, error };
    }
  }
}

export const productPricesService = new ProductPricesService();
